import type { IconSvgObject } from './types';

const TextCheckIcon: IconSvgObject = [
  ["path", { d: "M11 16.5C11 16.5 12.5 17 13.25 19C13.25 19 16.8235 13.1667 20 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 5H18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 10H15", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M4 15H8", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default TextCheckIcon;
